import type { RoundListItem } from "../../../shared/contracts/product-pages.js";

export function activityScore(round: RoundListItem): {
  value: string;
  label: string;
} {
  if (round.state === "disputed")
    return { value: "Review", label: "Result under review" };
  if (round.state === "voided") return { value: "—", label: "Result voided" };
  const measured = round.measuredResult;
  if (measured)
    return {
      value: measured.sides.map((side) => side.label).join(" – "),
      label: `${measured.activity} · ${measured.label}`,
    };
  const main = round.mainResult;
  if (main?.reviewStatus) return { value: "Review", label: main.reviewStatus };
  if (main) {
    const winners = main.sides
      .filter((side) => main.winnerSideIds.includes(side.id))
      .map((side) => side.name)
      .join(" & ");
    return {
      value:
        main.unit === "holes"
          ? main.label
          : main.sides.map((side) => side.value ?? "—").join(" – "),
      label: `${main.sides.length === 1 ? "Round recorded" : winners ? `${winners} ${main.tied ? "tied" : "won"}` : "Recorded"}${main.unit === "holes" ? "" : ` · ${main.scoringBasis} ${main.unit}`}`,
    };
  }
  const result = { win: "You won", loss: "You lost", tie: "Draw", none: "" }[
    round.outcome
  ];
  if (round.format === "match-play" && round.contestLabel)
    return { value: round.contestLabel, label: result || "Match result" };
  if (round.format === "stableford")
    return {
      value: round.stableford?.toString() ?? "—",
      label: result ? `${result} · pts` : "your points",
    };
  return {
    value: round.gross?.toString() ?? "—",
    label:
      round.gross === null
        ? round.state
        : result
          ? `${result} · strokes`
          : "your strokes",
  };
}
